import { cx } from '@linaria/core';
import { forwardRef, useState, useEffect } from 'react';
import { resets } from '@ui/css';
import { InputBorder } from './atom.input-border.js';
import { wrapper, input } from './text-input.style.js';
import { jsx } from 'react/jsx-runtime';

const TextInput = /*#__PURE__*/forwardRef(function TextInput({
  id,
  className,
  invalid,
  errorMessage,
  active,
  label,
  placeholder,
  value,
  onChange,
  ...props
}, ref) {
  // NB: We use an internvalValue to ensure that typing into the input is
  // immediately reflect even if the integration provides the actual value
  // slightly delayed.
  const [internalValue, setValue] = useState(value);
  const handleChange = evt => {
    setValue(evt.target.value);
    onChange(evt.target.value);
  };
  useEffect(() => {
    if (internalValue !== value) {
      setValue(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  const onKeyDown = evt => {
    if (value && evt.key === "Escape") {
      evt.stopPropagation();
      onChange("");
    }
    props.onKeyDown?.(evt);
  };
  return /*#__PURE__*/jsx("div", {
    className: cx(resets.rootCls, wrapper, className),
    children: /*#__PURE__*/jsx(InputBorder, {
      id: id,
      invalid: invalid,
      errorMessage: errorMessage,
      active: active,
      label: label,
      value: placeholder ?? value,
      readOnly: props.readOnly,
      children: /*#__PURE__*/jsx("input", {
        ...props,
        id: id,
        ref: ref,
        className: input,
        type: "text",
        value: internalValue,
        placeholder: placeholder,
        onChange: handleChange,
        onKeyDown: onKeyDown,
        "aria-required": props.required
      })
    })
  });
});

export { TextInput };
//# sourceMappingURL=text-input.js.map
